<template>
  <div>
    <b-container class="container-panel">
      <b-row align-v="end">
        <b-col cols="3">
          <img src="./assets/images/logoSmall.jpg"
               class="logo-margin"
               alt="Ambit Cares Logo"
               aria-label="Ambit Cares Logo" />
        </b-col>
        <b-col cols="9">
        </b-col>
      </b-row>
    </b-container>

    <b-container class="container-panel outlined-panel">
      <b-row>
        <b-col class="container-panel-heading">
          Errors Detected!
        </b-col>
      </b-row>
      <b-container>
        <b-row>
          <b-col cols="2">
            <font-awesome-icon icon="exclamation-circle"
                               size="3x"
                               style="color: red;">
            </font-awesome-icon>
          </b-col>
          <b-col cols="10"
                 class="align-left">
            <h4>
              Errors have been detected:
            </h4>
            <ul id="errorsList">
              <li v-for="error in getErrorsList()"
                  v-bind:key="error">
                {{ error }}
              </li>
            </ul>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="9">
          </b-col>
          <b-col cols="3">
            <b-button class="btn btn-primary btn-lg btn-margin-narrow-aligned-right float-right make-space-above"
                      title="Return to AmbitCares"
                      aria-label="Return to AmbitCares"
                      @click="returnToAmbitCares">
              Return to AmbitCares
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-container>

  </div>
</template>

<script>
  import utilities from '../utilities';

  export default {
    name: 'Error Report',

    data() {
      return {
      }
    },

    // -----------------------------------------------------------------------
    // The created method is part of the Vue.js lifecycle.
    // It gets called as the page is created. 
    // -----------------------------------------------------------------------
    created() {
      // This page is intended to report errors.  If the user is routed to here,
      // and there are no errors, then it is an error, so the user is re-routed
      // to the Unexpected (404-like) page
      if (!this.$store.getters.anyErrors) {
        this.$router.push('Unexpected');
      }
    },

    methods: {

      // -----------------------------------------------------------------------
      // Called with the user presses the "Return to AmbitCares" button.
      // the "utilities.returnToAmbitCares" function determines to which version(int or prod)
      // of the AmbitCares page the user should be routed. 
       // -----------------------------------------------------------------------
     returnToAmbitCares() {
        this.$store.commit('clearErrorMessages');
        utilities.returnToAmbitCares();
      },

      getErrorsList() {
        return this.$store.state.errorMessages;
      },

    },

  }

</script>
<style src="./assets/css/CommonVue.css" scoped>
</style>

<style scoped>
</style>
